import { getLocationFromProvider } from "./addressUtils";
import { getLibraryRequestDocumentName } from "./libraryRequestsGridMapper";

/**
 * Maps a sponsor org library request row to ProviderDetailCard / CustomCards props.
 */
export function mapSponsorOrgRequestToCardProps(item, isCatalogAdmin) {
  const isRfi = String(item?.document_type || "").toLowerCase() === "rfi";
  const catalogArchived = item?.catalog_document_status === "Archived";
  const displayStatus =
    isCatalogAdmin && catalogArchived
      ? "Archived"
      : item?.request_status ?? item?.document_status;

  const documentName = isRfi
    ? getLibraryRequestDocumentName(item)
    : item?.report_type || item?.document_name;

  const itemWithoutRequestPath = { ...(item || {}) };
  delete itemWithoutRequestPath.request_path;
  delete itemWithoutRequestPath.requestPath;

  return {
    documentType: item?.document_type,
    name: item?.provider_name,
    status: displayStatus,
    services: item?.capabilities ?? [],
    additionalScope: item?.additional_scope,
    publishedDate: item?.published_on,
    requestedDate: item?.requested_on,
    assessmentDate: item?.released_on,
    docLocation: getLocationFromProvider({
      city: item?.document_city,
      state: item?.document_state,
      country: item?.document_country,
    }),
    docLocationFull: getLocationFromProvider(
      {
        city: item?.document_city,
        state: item?.document_state,
        country: item?.document_country,
      },
      { short: false }
    ),
    documentName,
    entityId: item?.entity_id,
    docId: item?.document_id,
    details: {
      ...itemWithoutRequestPath,
      document_name: documentName,
      archive_comment:
        item?.catalog_archive_comment ?? item?.archive_comment ?? "",
      document_status: displayStatus,
    },
  };
}

export function mapVendorOrgLibraryDisplayStatus(status) {
  const normalized = String(status || "").trim();
  return normalized.toLowerCase() === "upcoming" ? "Pending" : status;
}

export function mapVendorCatalogItemToCardProps(item) {
  const displayStatus = mapVendorOrgLibraryDisplayStatus(item?.document_status);

  return {
    documentType: item?.entity_type,
    name: item?.provider_name,
    status: displayStatus,
    services: item?.capabilities ?? [],
    additionalScope: item?.additional_scope,
    publishedDate: item?.published_on,
    assessmentDate: item?.assessment_date,
    requestedDate: item?.requested_on,
    docLocation: getLocationFromProvider({
      address: item?.document_location,
      city: item?.document_city,
      state: item?.document_state,
      country: item?.document_country,
    }),
    docLocationFull: getLocationFromProvider(
      {
        address: item?.document_location,
        city: item?.document_city,
        state: item?.document_state,
        country: item?.document_country,
      },
      { short: false }
    ),
    documentName: item?.document_name,
    entityId: item?.entity_id,
    docId: item?.document_id,
    details: {
      ...(item || {}),
      document_status: displayStatus,
    },
    questionnaireId: item?.hc_questionnaire_id,
    isLegacyRfi: item?.is_legacy,
    v1_doc_id: item?.v1_mongo_id,
    v1_doc_name: item?.v1_document_name,
  };
}

/** Provider self-service org library rows come from Documents/Requests catalog mapping. */
export function mapVendorOrgLibraryItemToCardProps(item, isProviderSelfView = false) {
  if (!isProviderSelfView) {
    return mapVendorCatalogItemToCardProps(item);
  }

  return mapVendorCatalogItemToCardProps({
    entity_type: item?.document_type ?? item?.entity_type,
    provider_name: item?.provider_name,
    document_status: item?.request_status ?? item?.document_status,
    capabilities: item?.capabilities,
    additional_scope: item?.additional_scope,
    published_on: item?.published_on,
    assessment_date: item?.assessment_date ?? item?.released_on,
    requested_on: item?.requested_on,
    document_location: item?.document_location,
    document_city: item?.document_city,
    document_state: item?.document_state,
    document_country: item?.document_country,
    document_name: item?.document_name ?? item?.report_type,
    entity_id: item?.entity_id,
    document_id: item?.document_id,
    hc_questionnaire_id: item?.hc_questionnaire_id,
    is_legacy: item?.is_legacy,
    v1_mongo_id: item?.v1_mongo_id,
    v1_document_name: item?.v1_document_name,
  });
}
